import { Fetch } from 'lib';
import type { Tag } from 'types';

type RequestResponses = Tag;

type RequestParameters = {
  id: string;
};

const getTag = async (params: RequestParameters) =>
  await Fetch<RequestResponses, RequestParameters>({
    url: 'adminTag/getTag',
    params,
  });

export { getTag };
